import { updateData } from 'crustate';

var ORDER_RESPONSE = "response/order";
var ORDER_REQUEST = "request/order";
var load = function load(loadQuote) {
  if (loadQuote === void 0) {
    loadQuote = true;
  }
  return {
    tag: ORDER_REQUEST,
    loadQuote: loadQuote
  };
};
var OrderModel = {
  id: "order",
  init: function init() {
    return updateData({
      state: "LOADING"
    }, load());
  },
  update: function update(state, msg) {
    switch (msg.tag) {
      case ORDER_RESPONSE:
        if (msg.error) {
          return updateData({
            state: "ERROR",
            error: msg.error
          });
        }
        return updateData({
          state: "LOADED",
          data: msg.data ? msg.data : null
        });
      case ORDER_REQUEST:
        if (state.state === "LOADED" || state.state === "ERROR") {
          return updateData({
            state: "LOADING"
          }, load(msg.loadQuote));
        }
        break;
      default:
    }
  }
};

export { ORDER_REQUEST, ORDER_RESPONSE, OrderModel, load };
//# sourceMappingURL=index.esm.js.map
